import {Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'getDifferance',
  standalone: true
})
export class DateDifferancePipe implements PipeTransform {

  private static formatTime(duration: moment.Duration, ms: number): string {
    const hoursCount = Math.floor(duration.asHours());
    const hoursFormatted = hoursCount < 10 ? '0' + hoursCount : hoursCount;

    return hoursFormatted + moment.utc(ms).format(':mm:ss');
  }

  transform(dates: string[]): { formatted: string, inHours: number, inDays: number } {
    const now = moment(dates[1] || moment().format());
    const then = moment(dates[0] || moment().format());
    const ms = moment(now, 'DD/MM/YYYY HH:mm:ss').diff(moment(then, 'DD/MM/YYYY HH:mm:ss'));
    const duration = moment.duration(ms);

    return {
      formatted: DateDifferancePipe.formatTime(duration, ms),
      inHours: duration.asHours(),
      inDays: +duration.asDays().toFixed(0)
    };
  }
}
